module.exports = __webpack_public_path__ + "img/map.a267a1df.png";